import { inject, Injectable } from '@angular/core';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { EnvelopeService } from '@app/core/services/envelope.service';

@Injectable({ providedIn: 'root' })
export class PlCardService {
  private envelopeService = inject(EnvelopeService);

  getEnvelope(id: string) {
    return this.envelopeService.getEnvelope(id);
  }

  listPlCards(params?: any) {
    return this.envelopeService.listEnvelopes({
      '$sort[createdAt]': -1,
      'status[$nin]': 'voided',
      'meta.media.type': 'plcard',
      ...params,
    });
  }

  createPlCard(products: string[], file: NzUploadFile) {
    return this.envelopeService.createEnvelope(products, file, 'plcard');
  }

  pushExistingPlCard(productIds: string[], mediaId: string) {
    return this.envelopeService.pushExistingPlCard(productIds, mediaId);
  }

  removePlCard(id: string) {
    return this.envelopeService.removeEnvelope(id);
  }
}
